/* eslint-disable react/prop-types -- this codebase does not use propTypes (see CLAUDE.md). */
import { useState, useEffect } from "react";
import { initialsFrom } from "../utils/initials";

/**
 * Profile picture with a locally drawn initials fallback.
 *
 * `src` is normally the Google photo URL the Firebase token carries (users.avatar).
 * When it is missing — every password account — we draw initials ourselves rather
 * than calling out to ui-avatars.com, which used to receive the member's real name
 * in a query string on every render. A broken URL (photo deleted at Google) falls
 * back to the same initials instead of a broken image.
 *
 * Size and type scale come from `className`, e.g. "h-10 w-10 text-sm".
 */
export default function Avatar({ src, name, className = "h-10 w-10 text-sm" }) {
  const [failed, setFailed] = useState(false);

  // A different person (or a freshly uploaded photo) deserves another attempt.
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div
        aria-hidden="true"
        className={`flex shrink-0 items-center justify-center rounded-full bg-gray-200 font-semibold text-gray-600 ${className}`}
      >
        {initialsFrom(name)}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-full object-cover ${className}`}
    />
  );
}
